// extracted by mini-css-extract-plugin
module.exports = {"policiesContainer":"Policies-module--policiesContainer--1VgEg","text":"Policies-module--text--25P_j","chevronIcon":"Policies-module--chevronIcon--3SXOI"};